import React, { useEffect, useState, useRef } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import "antd/dist/antd.min.css";
import { debounce } from "lodash";

import { getRequest } from "../../axios";

import {
  DownloadOutlined,
  InsertRowLeftOutlined,
  UndoOutlined,
  FilterOutlined,
} from "@ant-design/icons";
import {
  Breadcrumb,
  Button,
  Checkbox,
  Col,
  Dropdown,
  Form,
  Input,
  Menu,
  Row,
  Space,
  Table,
  Tooltip,
  Select,
} from "antd";

import SearchIcon from "../../image/SearchIcon.svg";
import "../../styles/Main.scss";
import { ErrorNotificationMsg } from "../../utils/Notifications";

const CompanyWiseBillingReportAdmin = () => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const formRef = useRef();

  const { Option } = Select;
  const { Search } = Input;
  const [selectedRow, setSelectedRow] = useState([]);
  const [loading, setLoading] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);
  const [invoiceList, setInvoiceList] = useState([]);
  const [companyList, setCompanyList] = useState([]);

  const [totalCount, settotalCount] = useState(0);

  const [dropdownVisible, setDropdownVisible] = useState(false);
  const intialFilter = {
    transaction_type: "",

    trend: "",
    company_id: "",
    company_type: "",
  };

  const [stateFilter, setStateFilter] = useState(intialFilter);
  const [state, setState] = useState({
    page: 1,
    ordering: "id",
    pagesize: 10,
    search: "",
    total: 0,
  });
  useEffect(() => {
    getCompanyList();
  }, []);

  const getCompanyList = async (data) => {
    await getRequest("company/?no_pagination=true", data).then((response) => {
      setCompanyList(response.data.data);
    });
  };
  useEffect(() => {
    const getInvoiceList = async () => {
      setLoading(true);
      const queryParamsObject = {
        ...state,
        month: stateFilter?.month || null,
        company_id: stateFilter?.company_id || null,
        company_type: stateFilter?.company_type || null,
        trend: stateFilter?.trend || null,
        transaction_type: stateFilter?.transaction_type || null,

        page: state.page,
        ordering: state.ordering,
        pagesize: state.pagesize,
        search: state.search,
        total: state.total,
      };

      const queryParams = new URLSearchParams(
        Object.entries(queryParamsObject).reduce((acc, [key, value]) => {
          if (value !== null && value !== undefined) {
            acc[key] = value;
          }
          return acc;
        }, {})
      ).toString();

      try {
        let apiResponse = await getRequest(`invoice/?${queryParams}`);
        if (apiResponse?.data?.results?.success) {
          setInvoiceList(apiResponse?.data?.results?.data);
          settotalCount(apiResponse.data.count);
        } else {
          ErrorNotificationMsg(t("error_in_company_list"));
        }
        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    };
    getInvoiceList();
  }, [state, t]);

  const handleResetFilter = () => {
    setState({
      page: 1,
      ordering: "id",
      pagesize: 10,
      search: "",
      total: 0,
    });
    setStateFilter(intialFilter);

    form.setFieldsValue({ search: "" });

    formRef.current.setFieldsValue({
      month: undefined,
      due_date: undefined,
      trend: undefined,
      transaction_type: undefined,
      company_type: undefined,
      company: undefined,
    });
  };

  const handleTrendStatus = (value) => {
    setStateFilter((prevState) => ({
      ...prevState,
      trend: value,
    }));
  };
  const handleCompanyChange = (value) => {
    setStateFilter((prevState) => ({
      ...prevState,
      company_id: value,
    }));
  };
  const handleCompanyTypeChange = (value) => {
    setStateFilter((prevState) => ({
      ...prevState,
      company_type: value,
    }));
  };
  const handleTransactionTypeChange = (value) => {
    setStateFilter((prevState) => ({
      ...prevState,
      transaction_type: value,
    }));
  };
  const handleMonthChange = (value) => {
    setStateFilter((prevState) => ({
      ...prevState,
      month: value,
    }));
  };

  const handleApplyFilter = async () => {
    setState({
      // ...state,
      page: 1,
      ordering: "id",
      pagesize: 10,
      search: "",
      total: 0,
    });
  };

  const handleTableChange = async (pagination, filters, sorter, ordering) => {
    const orderBy = GetSortingEnumValue(sorter.columnKey, sorter.order);
    setState({
      ...state,
      page: pagination.current,
      pagesize: pagination.pageSize,
      ordering: orderBy,
    });
    setSelectedRow(selectedRow);
  };

  const handleReset = () => {
    setState({
      ...state,
      search: "",
    });

    form.setFieldsValue({ search: "" });
  };

  const GetSortingEnumValue = (sortField, sortOrder) => {
    let sortingEnumKey = "id";

    if (sortField === "invoice_to_name" && sortOrder === "ascend") {
      sortingEnumKey = "invoice_to_name";
    }
    if (sortField === "invoice_to_name" && sortOrder === "descend") {
      sortingEnumKey = "-invoice_to_name";
    }

    if (sortField === "company_type" && sortOrder === "ascend") {
      sortingEnumKey = "company__company_type";
    }
    if (sortField === "company_type" && sortOrder === "descend") {
      sortingEnumKey = "-company__company_type";
    }

    if (sortField === "invoice_number" && sortOrder === "ascend") {
      sortingEnumKey = "invoice_number";
    }
    if (sortField === "invoice_number" && sortOrder === "descend") {
      sortingEnumKey = "-invoice_number";
    }

    if (sortField === "month" && sortOrder === "ascend") {
      sortingEnumKey = "month";
    }
    if (sortField === "month" && sortOrder === "descend") {
      sortingEnumKey = "-month";
    }
    if (sortField === "remaining_days" && sortOrder === "ascend") {
      sortingEnumKey = "remaining_days";
    }
    if (sortField === "remaining_days" && sortOrder === "descend") {
      sortingEnumKey = "-remaining_days";
    }

    if (sortField === "amount" && sortOrder === "ascend") {
      sortingEnumKey = "amount";
    }
    if (sortField === "amount" && sortOrder === "descend") {
      sortingEnumKey = "-amount";
    }

    if (sortField === "due_date" && sortOrder === "ascend") {
      sortingEnumKey = "due_date";
    }
    if (sortField === "due_date" && sortOrder === "descend") {
      sortingEnumKey = "-due_date";
    }

    if (sortField === "trend" && sortOrder === "ascend") {
      sortingEnumKey = "trend";
    }
    if (sortField === "trend" && sortOrder === "descend") {
      sortingEnumKey = "-trend";
    }
    if (sortField === "transaction_type" && sortOrder === "ascend") {
      sortingEnumKey = "transaction_type";
    }
    if (sortField === "transaction_type" && sortOrder === "descend") {
      sortingEnumKey = "-transaction_type";
    }

    return sortingEnumKey;
  };

  const [checkedList, setCheckedList] = useState([
    "company_name",
    "company_type",
    "month",
    "parcel_scanned",
    "amount_paid",
    "amount_spent",
    "outstanding",
    "trend",
  ]);
  const [columns, setColumns] = useState([
    {
      title: "Company Name",
      dataIndex: "company_name",
      key: "company_name",
      sorter: true,
      width: 100,
      render: (dataIndex) => (
        <div
          style={{
            maxWidth: "400px",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            textTransform: "none",
          }}
        >
          {dataIndex}
        </div>
      ),
    },

    {
      title: "Company Type",
      dataIndex: "company_type",
      key: "company_type",
      sorter: true,
      width: 200,
      render: (dataIndex) => (
        <div
          style={{
            maxWidth: "400px",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            textTransform: "none",
          }}
        >
          {dataIndex}
        </div>
      ),
    },
    {
      title: "Month",
      dataIndex: "month",
      key: "month",
      sorter: true,
      width: 130,
      render: (dataIndex) => (
        // <Tooltip
        //   color={colors}
        //   placement="left"
        //   title={<span style={{ color: "#fff" }}>{dataIndex}</span>}
        // >
        <div
          style={{
            maxWidth: "400px",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {dataIndex}
        </div>
        // </Tooltip>
      ),
    },
    {
      title: "Parcels Scanned",
      dataIndex: "parcel_scanned",
      key: "parcel_scanned",
      sorter: true,
      width: 130,
      render: (_, record) =>
        record?.parcel_scanned ? record?.parcel_scanned : "-",
    },
    {
      title: "Amount Paid",
      dataIndex: "amount_paid",
      key: "amount_paid",
      width: 180,
      sorter: true,
    },
    {
      title: "Amount Spent",
      dataIndex: "amount_spent",
      key: "amount_spent",
      width: 180,
      sorter: true,
    },
    {
      title: "Outstanding",
      key: "outstanding",
      sorter: true,
      width: 130,
    },
    {
      title: "Trend",
      key: "trend",
      sorter: true,
      width: 130,
    },

    {
      title: "Action",
      key: "operation",
      fixed: "right",
      width: 100,
      render: (text, record) => (
        <Space>
          {/* <Tooltip title="View Invoice">
            <span
              //   onClick={() =>
              //     handleDownload(
              //       record.id,
              //       record.company_id,
              //       record?.company_type
              //     )
              //   }
              style={{ cursor: "pointer" }}
            >
              <EyeOutlined />
            </span>
          </Tooltip> */}
          <Tooltip title="Download Invoice">
            <span
              className="material-symbols-outlined"
              //   onClick={() => handleDownload(record.id, record?.company_type)}
              style={{ cursor: "pointer" }}
            >
              download
            </span>
          </Tooltip>
        </Space>
      ),
    },
  ]);

  useEffect(() => {
    const updatedColumns = columns.map((column) => ({
      ...column,
      hidden: !checkedList.includes(column.key),
    }));
    setColumns(updatedColumns);
  }, [checkedList, columns]);

  const handleColumnVisibilityChange = (checkedValues) => {
    setCheckedList(checkedValues);
  };

  const allColumns = [
    { key: "company_name", title: "Company Name" },
    { key: "company_type", title: "Company Type" },
    { key: "month", title: "Month" },
    { key: "parcel_scanned", title: "Parcels Scanned" },
    { key: "amount_paid", title: "Amount Paid" },
    { key: "amount_spent", title: "Amount Spent" },
    { key: "outstanding", title: "Outstanding" },
    { key: "trend", title: "Trends" },

    { key: "operation", title: "Actions" },
  ];

  const columnMenu = (
    <Menu className="packagelistdropdown">
      <Menu.Item>
        <Checkbox.Group
          value={checkedList}
          onChange={handleColumnVisibilityChange}
        >
          <Row>
            {allColumns.map((column) => (
              <Col span={12} key={column.key}>
                <Checkbox
                  value={column.key}
                  disabled={column.key === "operation"}
                >
                  {column.title}
                </Checkbox>
              </Col>
            ))}
          </Row>
        </Checkbox.Group>
      </Menu.Item>
    </Menu>
  );

  const searchCallbackDelayed = (event) => {
    const { value } = event.target;
    debounceLoadData(value, onSearch);
  };

  const onSearch = (value) => {
    setState({
      ...state,
      search: value,
    });
  };

  const debounceLoadData = debounce((value, onSearch) => {
    onSearch(value);
  }, 1000);

  const downloadCSV = async () => {
    setBtnLoading(true);
    const endpoint = `invoice/invoice-excel-download/`;
    const fileType = "csv";

    // Construct query parameters similar to getEmployeeList
    const queryParamsObject = {
      // ...state,
      month: stateFilter?.month || null,

      company_id: stateFilter?.company_id || null,
      company_type: stateFilter?.company_type || null,
      trend: stateFilter?.trend || null,
      transaction_type: stateFilter?.transaction_type || null,
      // page: state.page,
      ordering: state.ordering,
      // pagesize: state.pagesize,
      search: state.search,
      total: state.total,
    };

    const queryParams = new URLSearchParams(
      Object.entries(queryParamsObject).reduce((acc, [key, value]) => {
        if (value !== null && value !== undefined) {
          acc[key] = value;
        }
        return acc;
      }, {})
    ).toString();

    try {
      // Use getRequest with the constructed query parameters
      const response = await getRequest(`${endpoint}?${queryParams}`);

      // Process the response to download the CSV file
      const blob = new Blob([response.data], {
        type: "text/csv",
      });
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = `InvoiceReport${+new Date()}.${fileType}`;
      link.click();
      setBtnLoading(false);
    } catch (error) {
      setBtnLoading(false);
      if (error.response && error.response.status === 404) {
        console.error("File not found or endpoint is incorrect.");
        setBtnLoading(false);
      } else {
        console.error("Error downloading the file:", error);
        setBtnLoading(false);
      }
    }
  };
  const colors = ["#737373"];
  return (
    <>
      <div className="ListingTopBar">
        <div className="pagenamewrap">
          <div className="pagename">
            {/* <Tooltip
              color={colors}
              placement="right"
              title={
                <span style={{ color: "#fff" }}>
                  View & manage the list of company within the organization.
                </span>
              }
            > */}
            <h3>{t("Companies Billing Report")}</h3>
            {/* </Tooltip> */}

            <Breadcrumb className="Breadcrumb-Sec">
              <Breadcrumb.Item>
                <Link to="/dashboard">{t("home")}</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>{t("Companies Billing Report")}</Breadcrumb.Item>
            </Breadcrumb>
          </div>
          <Space>
            <div className="searchwrp">
              <Space direction="vertical">
                <Form form={form}>
                  <Form.Item name="search" initialValue="">
                    <Search
                      // value={state.search}
                      prefix={
                        <img
                          src={SearchIcon}
                          alt="SearchIcon"
                          className="SearchIcon"
                          width={22}
                        />
                      }
                      placeholder={t("pl_search_list")}
                      onChange={searchCallbackDelayed}
                    />
                  </Form.Item>
                </Form>
              </Space>
            </div>
            {state?.search ? (
              // <Tooltip title="Reset search">
              <Button
                className="BlueShadowBtn"
                type="primary"
                htmlType="button"
                onClick={() => handleReset()}
              >
                <span
                  style={{ display: "flex", alignItems: "center", gap: "5px" }}
                >
                  <UndoOutlined style={{ fontSize: "16px", color: "#fff" }} />{" "}
                  Reset
                </span>
              </Button>
            ) : (
              // </Tooltip>
              ""
            )}
            {/* <Tooltip
              color={colors}
              placement="right"
              title={
                <span style={{ color: "#fff" }}>
                  Add A New Company To The Organization&apos;s Database.
                </span>
              }
            > */}

            {/* </Tooltip> */}

            {/* <Tooltip placement="topLeft" title="Column Filter Options"> */}
            <div className="gridiconswrap">
              <Dropdown
                overlay={columnMenu}
                trigger={["click"]}
                placement="bottomRight"
                visible={dropdownVisible}
                onVisibleChange={(visible) => setDropdownVisible(visible)}
              >
                <Button
                  type="primary"
                  shape="circle"
                  icon={<InsertRowLeftOutlined />}
                  onClick={() => setDropdownVisible(!dropdownVisible)}
                />
              </Dropdown>
            </div>
            {/* </Tooltip> */}
          </Space>
        </div>
      </div>

      <section className="grid-sec">
        <div className="Package-body">
          <div className="filterrow packagefilter">
            <div className="filtercol">
              <Form autoComplete="off" ref={formRef}>
                <Space wrap>
                  <Col
                    xs={24}
                    sm={24}
                    md={24}
                    lg={24}
                    xl={24}
                    className="TextFeild gutter-row"
                  >
                    <Form.Item name="month" label={t("Month")}>
                      <Select
                        placeholder={t("Select Month")}
                        showArrow
                        showSearch
                        name="month"
                        value={state?.month}
                        optionFilterProp="children"
                        onChange={handleMonthChange}
                      >
                        <Option key="January" value="January">
                          January
                        </Option>
                        <Option key="February" value="February">
                          February
                        </Option>
                        <Option key="March" value="March">
                          March
                        </Option>
                        <Option key="April" value="April">
                          April
                        </Option>
                        <Option key="May" value="May">
                          May
                        </Option>
                        <Option key="June" value="June">
                          June
                        </Option>
                        <Option key="July" value="July">
                          July
                        </Option>
                        <Option key="August" value="August">
                          August
                        </Option>
                        <Option key="September" value="September">
                          September
                        </Option>
                        <Option key="October" value="October">
                          October
                        </Option>
                        <Option key="November" value="November">
                          November
                        </Option>
                        <Option key="December" value="December">
                          December
                        </Option>
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col
                    xs={24}
                    sm={24}
                    md={24}
                    lg={24}
                    xl={24}
                    className="TextFeild gutter-row"
                  >
                    <Form.Item name="company" label={t("pl_company")}>
                      <Select
                        placeholder={t("pl_select_company")}
                        showArrow
                        showSearch
                        name="company"
                        value={state?.company}
                        optionFilterProp="children"
                        onChange={handleCompanyChange}
                      >
                        {companyList.map((company) => (
                          <Option key={company.id} value={company.id}>
                            {company.company_name}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col
                    xs={24}
                    sm={24}
                    md={24}
                    lg={24}
                    xl={24}
                    className="TextFeild gutter-row"
                  >
                    <Form.Item
                      name="company_type"
                      label={t("label_company_type")}
                    >
                      <Select
                        placeholder={t("pl_select_company_type")}
                        showArrow
                        showSearch
                        name="company_type"
                        value={state?.company_type}
                        optionFilterProp="children"
                        onChange={handleCompanyTypeChange}
                      >
                        <Option key="Pre Paid" value="Pre Paid">
                          Pre Paid
                        </Option>
                        <Option key="Post Paid" value="Post Paid">
                          Post Paid
                        </Option>
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col
                    xs={24}
                    sm={24}
                    md={24}
                    lg={24}
                    xl={24}
                    className="TextFeild gutter-row"
                  >
                    <Form.Item
                      name="transaction_type"
                      label={t("Transaction Type")}
                      value={state?.transaction_type}
                    >
                      <Select
                        showArrow
                        placeholder={t("Select Type")}
                        onChange={(value) => handleTransactionTypeChange(value)}
                      >
                        <Option key="recharge" value="recharge">
                          Recharge
                        </Option>
                        <Option key="payment" value="payment">
                          Payment
                        </Option>
                        <Option key="adjustment" value="adjustment">
                          Adjustment
                        </Option>
                        <Option
                          key="recharge_initiated"
                          value="recharge_initiated"
                        >
                          Recharge Initiated
                        </Option>
                        <Option
                          key="payment_initiated"
                          value="payment_initiated"
                        >
                          Payment Initiated
                        </Option>
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col
                    xs={24}
                    sm={24}
                    md={24}
                    lg={24}
                    xl={24}
                    className="TextFeild gutter-row"
                  >
                    <Form.Item
                      name="trend"
                      label={t("Trend")}
                      value={state?.trend}
                    >
                      <Select
                        showArrow
                        placeholder={t("Select Trend")}
                        onChange={(value) => handleTrendStatus(value)}
                      >
                        <Option key="Up" value="Up">
                          Up
                        </Option>
                        <Option key="Down" value="Down">
                          Down
                        </Option>
                      </Select>
                    </Form.Item>
                  </Col>
                </Space>
              </Form>
            </div>
            <div className="btnscol btncolpack">
              <Space className="btnpack">
                <>
                  {/* <Tooltip title="Apply Filter"> */}
                  <Button
                    className="SaveGradiantBtn"
                    type="primary"
                    htmlType="Apply"
                    // label="Apply"
                    onClick={handleApplyFilter}
                  >
                    <span
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "5px",
                      }}
                    >
                      <FilterOutlined style={{ fontSize: "16px" }} /> Apply
                      Filter
                    </span>
                  </Button>
                  {/* </Tooltip> */}
                  {stateFilter?.month ||
                  stateFilter?.trend ||
                  stateFilter?.company_id ||
                  stateFilter?.company_type ||
                  stateFilter?.transaction_type ? (
                    // <Tooltip title="Reset Filter">
                    <Button
                      className="SaveGradiantBtn"
                      type="primary"
                      htmlType="Reset"
                      // label="Reset"
                      onClick={handleResetFilter}
                    >
                      <span
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "5px",
                        }}
                      >
                        <UndoOutlined
                          style={{ fontSize: "16px", color: "#fff" }}
                        />{" "}
                        Reset
                      </span>
                    </Button>
                  ) : (
                    // </Tooltip>
                    ""
                  )}
                </>
                {/* <Tooltip title="Download CSV"> */}
                <Button
                  className="SaveGradiantBtn"
                  type="primary"
                  htmlType="DownloadPDF"
                  // label="Download CSV"
                  onClick={downloadCSV}
                  loading={btnLoading}
                >
                  <span
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                    }}
                  >
                    <DownloadOutlined style={{ fontSize: "16px" }} /> Download
                    CSV
                  </span>
                </Button>
                {/* </Tooltip> */}
              </Space>
            </div>
          </div>
          <Table
            // rowSelection={rowSelection}
            columns={columns.filter((col) => !col.hidden)}
            rowKey={(record) => record.id}
            dataSource={invoiceList}
            loading={loading}
            pagination={{
              defaultCurrent: state.page,
              defaultPageSize: state.pagesize,
              total: totalCount,
              showTotal: (total) => `Total ${total} items`,
              showSizeChanger: true,
              locale: {
                items_per_page: "Items / Page",
              },
            }}
            onChange={handleTableChange}
            scroll={{
              x: 1000,
            }}
          />
        </div>
      </section>
    </>
  );
};
export default CompanyWiseBillingReportAdmin;
